import useIsBreakpoint from "./useIsBreakpoint";

export const useIsMobile = () => useIsBreakpoint("md");
